// Eta design tokens (from the Figma variables), shared by the GMPRO Proposed-tab
// components. Applied via inline styles because the project runs Tailwind 1.9.6,
// which has no arbitrary-value support. One source so the palette can't drift
// between the card and the reject sheet.
export const ETA = {
  purple: '#745D96',
  confirm: '#5DA876',
  error: '#FF0000',
  darkGrey: '#6E6C71',
  grey: '#9B999E',
  body: '#F8F7F9',
  divider: 'rgba(110,108,113,0.5)',
  cardBorder: 'rgba(153,153,153,0.3)',
  disabled: '#C4C7CC',
  inputBorder: '#D9D9D9',
  placeholder: '#A1A6AD',
};

export default ETA;
